export const SUBMITTED_TO_PITCH = 'SUBMITTED_TO_PITCH';

export function submittedToPitch(notificationId, params) {
  const { investorId, submissionId } = params;

  window.location = `/page-management/investor/${investorId}/submissions/${submissionId}`;
}
